module.exports = __webpack_public_path__ + "img/eikastiko_FOOTER.fbbeecaa.png";